import { makeStyles } from '@material-ui/core';
import { styles, colors } from '../design';
import { style } from '../resources/residents.styles';
export const useStyles = makeStyles(theme => ({
  ...style(theme),
  listActionWrapper: {
    ...styles.flexRow,
    ...styles.justifyBetween,
    width: '100%',
    flexWrap: 'wrap',
    paddingBottom: 0,
  },
  title: {
    fontStyle: 'Nunito Sans',
    fontSize: 20,
    fontWeight: 'bold',
    color: colors.black,
    paddingLeft: 12,
    marginBottom: 10,
  },
  fileIcons: {
    color: '#E32939', 

  },
  viewIcon: {
    color: '#5C738E'
  },
  emailLogBtn: {
    marginRight: 10,
    textTransform: 'capitalize',
    fontSize: '1rem',
    color: '#1061A0', backgroundColor: '#EFF4FB'
  },
  editIcon: {
    color:'#5C738E',
    fontSize: 18,
    marginLeft: 7,
    cursor: 'pointer',
  },
}));
